import React from 'react';
import PropTypes from 'prop-types';
import { LocaleService } from '@sm360/widget-commons-core-services';
import { CurrencyFormats } from '@sm360/widget-commons-vehicle';
import './TaxSavingsItem.scss';

const TaxSavingsItem = ({ content, style, dataTest }) => {
    return (
        <div className="TaxSavingsItem__body">
            <div className="TaxSavingsItem__body-left">
                <icon className={content.iconStyles.join('')} />
            </div>
            <div className="TaxSavingItem__body-right">
                <p className="sr-text">{content.label}</p>
                <p className="sr-subtitle-2" style={style} data-test={dataTest}>
                    {LocaleService.l(content.value, CurrencyFormats.CURRENCY_0)}
                </p>
            </div>
        </div>
    );
};

TaxSavingsItem.defaultProps = {
    style: {
        fontSize: '14px',
        color: 'inherit',
    },
    dataTest: '',
};

TaxSavingsItem.propTypes = {
    content: PropTypes.shape({
        label: PropTypes.string.isRequired,
        value: PropTypes.number.isRequired,
        iconStyles: PropTypes.arrayOf(PropTypes.string).isRequired,
    }).isRequired,
    style: PropTypes.shape({
        fontSize: PropTypes.string,
        color: PropTypes.string,
    }),
    dataTest: PropTypes.string,
};

TaxSavingsItem.displayName = 'TaxSavingsItem';

export default TaxSavingsItem;



// WEBPACK FOOTER //
// ./src/components/EstimateTradeIn/components/TaxSavings/TaxSavingsItem/TaxSavingsItem.jsx